<mat-form-field appearance="fill">
    <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [min]="datePickerSettings.rangeLimits.startDate"
        [max]="datePickerSettings.rangeLimits.endDate">
        <input readonly matStartDate formControlName="startDate" placeholder="Start date" />
        <input (dateChange)="handleDateRangeChange()" readonly matEndDate formControlName="endDate"
            placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
